module.exports = __webpack_public_path__ + "img/social-proofs-add.aedf2771.svg";